import type { PagedResultDto } from "@services/dto/pagedResultDto"
import accountingDocumentTypeService from "@services/master-data/accountingData/accountingDocumentTypeService"
import { action, makeAutoObservable, observable } from "mobx"

class AccountingDocumentTypeStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
  }
  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await accountingDocumentTypeService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }
  @action
  async initDetail() {
    this.detailData = {
      id: 0,
    }
  }
  @action
  async active(id: number, isActive) {
    this.isLoading = true
    await accountingDocumentTypeService
      .activate(id, isActive)
      .finally(() => (this.isLoading = false))
  }
  @action
  async get(id: number) {
    this.isLoading = true
    const result = await accountingDocumentTypeService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }
  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await accountingDocumentTypeService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
}

export default AccountingDocumentTypeStore
